/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Grid, Box, Container } from '@material-ui/core';
import { Element, scroller } from 'react-scroll';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

import ClubCommunityAll from './ClubCommunityAll';
import useCommunityList from '../../../hooks/useCommunityList';
import useClubs from '../../../hooks/useClubs';
import ViewPublic from '../ViewPublic/ViewPublic';

const ViewAllClub = () => {
  const loc = useLocation();
  const params = useParams();
  const key = 'iFrasCwdJh';
  const [communityDetails, setCommunityDetails] = useState(null);
  const { getCommunityBasicInfo } = useCommunityList();
  const clubsHook = useClubs();
  let bytes = null;
  let loggedInUserData = null;
  const userCookie = Cookies.get('user');
  const [isAccessible, setIsAccessible] = useState(false);

  if (userCookie) {
    bytes = CryptoJS.AES.decrypt(userCookie, key);
    loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }
  const [userId] = useState(loggedInUserData?.id);
  const [publicView, setPublicView] = useState(false);

  const fillCommunityDetails = async () => {
    let communityDetailsResults = [];
    if (params?.id) {
      communityDetailsResults = await getCommunityBasicInfo({
        communityId: params?.id,
        userId,
      });
      setCommunityDetails(communityDetailsResults.data);
    }
    return communityDetailsResults?.data;
  };

  const hashFragment = loc.hash.substring(1);

  useEffect(() => {
    // Scroll to Section1 with offset of -100 when component mounts
    if (hashFragment) {
      setTimeout(() => {
        scroller.scrollTo(hashFragment, {
          duration: 500,
          spy: true,
          smooth: true,
          offset: -140,
        });
      }, 1500);
    }
  }, [loc]);

  useEffect(() => {
    fillCommunityDetails();
  }, []);

  useEffect(() => {
    console.log(communityDetails?.userrole?.[0]?.id, loggedInUserData?.id, 1000000000);
    setIsAccessible(
      (loggedInUserData?.id && communityDetails?.userrole?.[0]?.id === loggedInUserData?.id) ||
        loggedInUserData?.roleId === 2,
    );
  }, [communityDetails]);

  return (
    <Box className="ViewAllAmenitiesContainer">
      {communityDetails ? (
        <Box component="div" className="PageSpacing">
          <Container className="CustomContainer">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              className="ViewAmenitiesContent"
              spacing={3}
            >
              <Grid item xs={12} sm={12} className="ViewAmenityGrid">
                <Box component="div" className="">
                  <If condition={isAccessible && publicView}>
                    <ViewPublic setPublicView={setPublicView} />
                  </If>

                  <Element name="Section12">
                    <ClubCommunityAll
                      communityInfo={communityDetails}
                      isAccessible={isAccessible}
                      publicView={publicView}
                      clubsHook={clubsHook}
                    />
                  </Element>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      ) : (
        <>
          <Container>
            <Grid container className="PageSpacing">
              <Grid item xs={12}>
                No content to display
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </Box>
  );
};

ViewAllClub.defaultProps = {};
export default ViewAllClub;
